import React from 'react'
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom'; 
import PageNav from '../../../shared/pageNav';

export default function Sidebar() {

  const {t} = useTranslation();

  return (
    <PageNav>
      <div className='sidebar-menu'>
        <ul>
          <li>
            <NavLink end to={'/restaurant/order-management'}>
              <i className='ti ti-brand-airtable'></i>
              <span>{t("label_order_dashboard")}</span>
            </NavLink>
          </li>
          <li>
            <NavLink end to={'/restaurant/order-management/vendor-management/list/1'}>
              <i className='ti ti-circle-check'></i>
              <span>{t("label_vendor_management")}</span>
            </NavLink>
          </li>
             <li>
            <NavLink end to={'/restaurant/order-management/product-management/list/1'}>
              {/* <i className='ti ti-clipboard-list'></i> */}
              <i className="ti ti-package"></i>
              <span>{t("label_product_management")}</span>
            </NavLink>
          </li>
          <li>
            <NavLink end to={'/restaurant/order-management/order-management/list/1'}>
              <i className='ti ti-clipboard-list'></i>
              <span>{t("label_order_management")}</span>
            </NavLink>
          </li>
           {/* <li>
            <NavLink end to={'/restaurant/order-management/vendor-management/list/1'}>
              <i className='ti ti-circle-check'></i>
              <span>{t("label_vendor_management")}</span>
            </NavLink>
          </li>  */}

            <li>
            <NavLink end to={'/restaurant/order-management/payment-management/list/1'}>
              <i className='ti ti-circle-check'></i>
              <span>{t("label_payment_management")}</span>
            </NavLink>
          </li> 

        </ul>
      </div>
    </PageNav>
  )
}
